import { render, staticRenderFns } from "./Tai-Chinh.vue?vue&type=template&id=29c30b60&scoped=true"
import script from "./Tai-Chinh.vue?vue&type=script&lang=js"
export * from "./Tai-Chinh.vue?vue&type=script&lang=js"
import style0 from "./Tai-Chinh.vue?vue&type=style&index=0&id=29c30b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c30b60",
  null
  
)

export default component.exports